import { apiCall } from "./api";

const URL = "/api/v1/manage-dashboard/user-specializations";

export const getManageUserSpecializations = () => {
  return apiCall(URL, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const createUserSpecialization = (data) => {
  return apiCall(URL, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};

export const updateUserSpecialization = (specializationId, data) => {
  return apiCall(`${URL}/${specializationId}`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};

export const deleteUserSpecialization = (specializationId) => {
  return apiCall(`${URL}/${specializationId}`, {
    method: "DELETE",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const resetUserSpecializationsToDefaults = () => {
  return apiCall(`${URL}/reset-defaults`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};
